<script>
	import Badge from '../Badge/Badge.svelte';
	import Icon from '../Icon/Icon.svelte';

	/** @type {boolean | RegExpMatch | null} */
	export let active = false;
	/** @type {number | string} */
	export let badgeLabel = '';
	/** @type {String} */
	export let href;
	export let icon = '';
	export let label = '';
</script>

<a class="tab-bar-item" class:active {href}>
	<slot name="icon">
		{#if icon}
			<Icon name={icon} --size="1.375rem" />
		{/if}
	</slot>

	{#if $$slots.default || label}
		<span class="label">
			<slot>
				{label}
			</slot>
		</span>
	{/if}

	{#if badgeLabel}
		<Badge label={badgeLabel} size="xs" --hsl-badge-background="var(--hsl-secondary)" />
	{/if}
</a>

<style>.tab-bar-item{background:hsla(var(--hsl-white));color:hsla(var(--hsl-gray));display:inline-grid;align-items:center;justify-items:center;place-items:center;gap:.25rem;padding:.375rem .625rem;position:relative;transition:all var(--time-xs) ease-out}.tab-bar-item.active,.tab-bar-item:focus,.tab-bar-item:hover{background:hsla(var(--hsl-primary),.05);color:hsla(var(--hsl-primary))}.tab-bar-item :global(.badge){position:absolute;left:50%;top:50%;translate:calc(-50% + .75rem) calc(-50% - 1rem)}.tab-bar-item span{font:var(--f-ui-xs-medium)}</style>
